import React from "react";
import {Modal} from "semantic-ui-react";
import './getCoursePaymentDetails.scss'
import {lang, language} from "../../../const/language";
import {Button, Col, Row} from "reactstrap";
import * as constants from "../../../const/constants";
import Files from "react-files";
import * as commonFunc from "../../../utils/commonFunc";

class getCoursePaymentDetails extends React.Component {

    state = {
        depSlip: '',
        type: '',
        installmentId: '',
        courseId: '',
        userType: '',
        totalPayment: '',
        teacher: {
            teacherName: "",
            qualification: "",
            description: "",
            imageUrl: "",
            bankNumber: "",
            bankName: "",
            branchName: "",
            accHolderName: ""
        }
    };

    async componentDidMount() {

        console.log("INSTALLMENT")
        console.log(this.props.installmentId);

        await this.setState({installmentId: this.props.installmentId});
        this.setState({courseId: this.props.courseId});
        this.setState({totalPayment: this.props.totalPayment});
        await this.setState({userType: this.props.userType});

        if (this.props.teacher) {
            this.setState({teacher: this.props.teacher});
        }

    }

    onFilesChange = async files => {
        if (files.length !== 0) {
            let file = files[0];
            const imageDataUrl = await commonFunc.readFile(file);
            await this.setState({
                type: file.type,
                depSlip: imageDataUrl
            });
            this.purchaseHandler(constants.SLIP_TYPE)
        }
        // console.log(this.state.depSlip ,this.state.installmentId , this.state.courseId);


    };

    purchaseHandler = async (status) => {
        let {depSlip} = this.state;
        // console.log(this.state.userType, this.state.courseId, this.state.installmentId, depSlip, this.props.history, status);
        console.log(this.state.installmentId);
        commonFunc.CoursePurchaseWarning(this.state.userType, this.state.courseId, this.state.installmentId, depSlip, this.props.history, status, this.state.totalPayment);
    };


    render() {
        return (
            <Modal size={"tiny"} open={true} centered={true} className='getCoursePaymentDetails'>
                <Modal.Header>
                    <div className={"header-wrapper"}>
                        <p>{language[lang].payInstallments}</p>
                        <div align="right"><i className="fa fa-close" aria-hidden="true"
                                              onClick={this.props.closeModal}/></div>
                    </div>
                </Modal.Header>
                <Modal.Content>
                    <Row>
                        <Col xs={12}>
                            <div align='center'>
                                {/*{this.props.totalPayment != '' ?*/}
                                {/*    <p>*/}
                                {/*        {language[lang].courseAmountToPay} Rs{this.props.totalPayment}.00*/}
                                {/*    </p> :null*/}
                                {/*}*/}
                                {/*{this.props.installmentPayment!== '' ?*/}
                                {/*    <p>*/}
                                {/*    {language[lang].courseAmountToPay} Rs{this.props.installmentPayment}.00*/}
                                {/*</p> :null*/}
                                {/*}*/}

                            </div>
                        </Col>

                        <Col xs={12} className={"card-section"}>
                            <div className={"align-left"}>
                                <Button className="log-btn com-btn"
                                        onClick={() => this.purchaseHandler(constants.CARD_TYPE)}>
                                    {language[lang].PayByCard}
                                </Button>
                            </div>
                            <div className={"payment-note-wrapper"}>
                                <p>
                                    {language[lang].cardPayment}
                                </p>
                            </div>
                        </Col>

                        <Col xs={12} className={"or-section"}>
                            <p>- {language[lang].OrText} -</p>
                        </Col>

                        {
                            this.state.teacher &&
                            <Col xs={12}>
                                <div>
                                    <p>Bank Number : <span style={{color:'black',fontWeight:'bold'}}>{this.state.teacher.bankNumber}</span></p>
                                    <p>Bank Name : <span style={{color:'black',fontWeight:'bold'}}>{this.state.teacher.bankName}</span></p>
                                    <p>Branch Name : <span style={{color:'black',fontWeight:'bold'}}>{this.state.teacher.branchName}</span></p>
                                    <p>Acc Holder Name : <span style={{color:'black',fontWeight:'bold'}}>{this.state.teacher.accHolderName}</span></p>
                                </div>
                            </Col>
                        }

                        <Col xs={12} className={"slip-section"}>
                            <label>{language[lang].ChooseBankDepositSlip}</label>
                            <div className={"files-wrapper"}>
                                <Files
                                    className='files-dropzone-file'
                                    onChange={this.onFilesChange}
                                    accepts={["image/png", "image/jpg", "image/jpeg"]}
                                    multiple={false}
                                    maxFileSize={10485760}
                                    minFileSize={0}
                                    onError={commonFunc.onFileError}
                                    clickable
                                >
                                    <div className="file-wrapper">
                                        <p className="file-text">
                                            {language[lang].DragHereText} {this.state.depSlip !== '' ? <span> |
                                            <span className={"a-link"}
                                                  onClick={() => commonFunc.getB64ToBlob(this.state.depSlip, this.state.type)}>
                                                {language[lang].ViewSlip}</span> </span> : null}</p>
                                    </div>
                                </Files>
                            </div>

                        </Col>
                    </Row>

                </Modal.Content>
            </Modal>
        )
    }
}

export default getCoursePaymentDetails;